import { createReducer } from 'reduxsauce'
import { Record } from 'immutable'
import { settingsTypes } from '.'

export const INITIAL_STATE = new Record({
	profile: {
		firstName: null,
		lastName: null,
		email: null,
		theme: null,
		reports: null,
		image: null,
	},
	team: [],
	invites: [],
	achievements: [],

	// Loading states
	loading: false,
	userImageUploadPending: false,
	userImageUploadSuccessful: false,
	teamImageUploadPending: false,
	teamImageUploadSuccessful: false,
	teamLogoUploadPending: false,
	teamLogoUploadSuccessful: false,
	teamLogoNegativeUploadPending: false,
	teamLogoNegativeUploadSuccessful: false,
	teamFaviconUploadPending: false,
	teamFaviconUploadSuccessful: false,
})

export const getProfileSuccess = (state, { profile }) =>
	state.merge({ profile, loading: false })

export const updateUserImageRequest = state =>
	state.merge({
		userImageUploadPending: true,
		userImageUploadSuccessful: false,
	})

export const updateUserImageSuccess = (state, { profile }) =>
	state.merge({
		profile,
		userImageUploadPending: false,
		userImageUploadSuccessful: true,
	})

export const updateTeamImageRequest = state =>
	state.merge({
		teamImageUploadPending: true,
		teamImageUploadSuccessful: false,
	})

export const updateTeamImageSuccess = state =>
	state.merge({
		teamImageUploadPending: false,
		teamImageUploadSuccessful: true,
	})

export const updateTeamLogoRequest = state =>
	state.merge({
		teamLogoUploadPending: true,
		teamLogoUploadSuccessful: false,
	})

export const updateTeamLogoSuccess = state =>
	state.merge({
		teamLogoUploadPending: false,
		teamLogoUploadSuccessful: true,
	})

export const updateTeamLogoNegativeRequest = state =>
	state.merge({
		teamLogoNegativeUploadPending: true,
		teamLogoNegativeUploadSuccessful: false,
	})

export const updateTeamLogoNegativeSuccess = state =>
	state.merge({
		teamLogoNegativeUploadPending: false,
		teamLogoNegativeUploadSuccessful: true,
	})

export const updateTeamFaviconRequest = state =>
	state.merge({
		teamFaviconUploadPending: true,
		teamFaviconUploadSuccessful: false,
	})

export const updateTeamFaviconSuccess = state =>
	state.merge({
		teamFaviconUploadPending: false,
		teamFaviconUploadSuccessful: true,
	})

export const updateProfileSuccess = (state, { profile }) =>
	state.mergeDeep({ profile })
export const getTeamSuccess = (state, { team }) =>
	state.merge({ team, loading: false })
export const getAchievementsSuccess = (state, { achievements }) =>
	state.merge({ achievements, loading: false })
export const updateTeamMemberSuccess = (state, { member }) =>
	state.merge({
		team: state.team.map(cMember => {
			if (member.id === cMember.id) return member

			return cMember
		}),
	})
export const removeTeamMemberSuccess = (state, { member }) =>
	state.merge({ team: state.team.filter(cMember => member !== cMember.id) })
export const getInvitesSuccess = (state, { invites }) =>
	state.merge({ invites })
export const removeInviteSuccess = (state, { invite }) =>
	state.merge({
		invites: state.invites.filter(cInvite => invite !== cInvite.id),
	})

export const setLoadingState = (state, { s }) => state.merge({ loading: s })

export const reducer = createReducer(INITIAL_STATE(), {
	[settingsTypes.GET_PROFILE_SUCCESS]: getProfileSuccess,
	[settingsTypes.UPDATE_PROFILE_SUCCESS]: updateProfileSuccess,
	[settingsTypes.GET_TEAM_SUCCESS]: getTeamSuccess,
	[settingsTypes.GET_ACHIEVEMENTS_SUCCESS]: getAchievementsSuccess,
	[settingsTypes.UPDATE_TEAM_MEMBER_SUCCESS]: updateTeamMemberSuccess,
	[settingsTypes.REMOVE_TEAM_MEMBER_SUCCESS]: removeTeamMemberSuccess,
	[settingsTypes.GET_INVITES_SUCCESS]: getInvitesSuccess,
	[settingsTypes.REMOVE_INVITE_SUCCESS]: removeInviteSuccess,
	[settingsTypes.UPDATE_USER_IMAGE_REQUEST]: updateUserImageRequest,
	[settingsTypes.UPDATE_USER_IMAGE_SUCCESS]: updateUserImageSuccess,
	[settingsTypes.UPDATE_TEAM_IMAGE_REQUEST]: updateTeamImageRequest,
	[settingsTypes.UPDATE_TEAM_IMAGE_SUCCESS]: updateTeamImageSuccess,
	[settingsTypes.UPDATE_TEAM_LOGO_REQUEST]: updateTeamLogoRequest,
	[settingsTypes.UPDATE_TEAM_LOGO_SUCCESS]: updateTeamLogoSuccess,
	[settingsTypes.UPDATE_TEAM_LOGO_NEGATIVE_REQUEST]: updateTeamLogoNegativeRequest,
	[settingsTypes.UPDATE_TEAM_LOGO_NEGATIVE_SUCCESS]: updateTeamLogoNegativeSuccess,
	[settingsTypes.UPDATE_TEAM_FAVICON_REQUEST]: updateTeamFaviconRequest,
	[settingsTypes.UPDATE_TEAM_FAVICON_SUCCESS]: updateTeamFaviconSuccess,
	[settingsTypes.SET_LOADING_STATE]: setLoadingState,
})
